//context transverse
import { createContext, useContext, useState } from 'react';

const AppContext = createContext();

export const useAppContext = () => useContext(AppContext);

export function AppProvider({ children }) {
  const [globalEvent, setGlobalEvent] = useState(null);
  const [showOnboarding, setShowOnboarding] = useState(false);
  const [showOnboardingV2, setShowOnboardingV2] = useState(false);

  // Fonction pour ouvrir manuellement le tutoriel (depuis le menu)
  const openTutorial = () => {
    setShowOnboarding(true);
  };

  // Fonction pour fermer le tutoriel
  const closeTutorial = () => {
    setShowOnboarding(false);
  };

  // Fonction pour ouvrir l'ancien tutoriel du dashboard V2 (depuis le menu, pour comparaison)
  const openTutorialV2 = () => {
    setShowOnboardingV2(true);
  };

  // Fonction pour fermer l'ancien tutoriel du dashboard V2
  const closeTutorialV2 = () => {
    setShowOnboardingV2(false);
  };

  return (
    <AppContext.Provider
      value={{
        globalEvent,
        setGlobalEvent,
        showOnboarding,
        setShowOnboarding,
        openTutorial,
        closeTutorial,
        showOnboardingV2,
        setShowOnboardingV2,
        openTutorialV2,
        closeTutorialV2
      }}
    >
      {children}
    </AppContext.Provider>
  );
}

